import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

export function OAuthPopupCallback() {
  const [searchParams] = useSearchParams();
  const sent = useRef(false);

  useEffect(() => {
    if (sent.current) return;
    sent.current = true;

    const status = (searchParams.get('oauth') || searchParams.get('zoom')) === 'success' ? 'success' : 'error';
    const account = searchParams.get('account');

    if (window.opener) {
      window.opener.postMessage(
        { type: 'zoom-oauth-complete', status, account },
        window.location.origin,
      );
      window.close();
    }
  }, [searchParams]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background text-foreground">
      <p className="text-sm text-muted-foreground">Authorization complete. You can close this window.</p>
    </div>
  );
}
